<span *ngIf="currentDefinition">
  <mat-icon matListIcon [style.color]="currentDefinition.color" *ngIf="currentDefinition.iconName; else circle">{{currentDefinition.iconName}}</mat-icon>
</span>
<div>{{enumText}}</div>

<ng-template #circle>
  <span class="circle-status" [style.background]="currentDefinition.color"></span>
</ng-template>
